module.exports = __webpack_public_path__ + "static/media/winC.89f847cf.png";